import { Box, Grid, Card, CardHeader, FormControl, TextField, Checkbox, FormControlLabel, Button } from "@mui/material";
import { useState } from "react";
import Page from "../../components/Page";
import axios from "axios";

export default function CreateRoles() {
  const [permissionName, setPermissionName] = useState("");
  const [rolePermission, setRolePermission] = useState({
    devices: [],
    portal: [],
  });

  const ALL_PERMISSIONS = {
    devices: ["view", "create"],
    portal: ["view", "create"],
  };

  const isAllChecked =
    ALL_PERMISSIONS.devices.every((p) => rolePermission.devices.includes(p)) &&
    ALL_PERMISSIONS.portal.every((p) => rolePermission.portal.includes(p));

  const handleAll = (e) => {
    if (e.target.checked) {
      setRolePermission(ALL_PERMISSIONS);
    } else {
      setRolePermission({ devices: [], portal: [] });
    }
  };

  const handleCheckbox = (group, value) => (e) => {
    setRolePermission((prev) => {
      const checked = e.target.checked;

      const updatedGroup = checked
        ? [...new Set([...prev[group], value])]
        : prev[group].filter((item) => item !== value);

      return { ...prev, [group]: updatedGroup };
    });
  };

  const submitForm = async (e) => {
    e.preventDefault();

    await axios.post("/api/save-user-permission", {
      permission_name: permissionName,
      rolePermission,
    });

    alert("Permissions saved!");
  };

  return (
    <Page className="Role" title="Create Role">
      <Grid container spacing={2}>
        <Grid item xs={12}>
            <Card className="RoleCard">
                <CardHeader title="Create Role" className="RolePageHeading" />
                <Grid container spacing={2} className="RoleCardBody">
                 <Grid item xs={12}>
                    <form onSubmit={submitForm}>
                        <Box className="BoxWidth">
                            <FormControl fullWidth>
                            <TextField
                                label="Permission Name"
                                value={permissionName}
                                onChange={(e) => setPermissionName(e.target.value)}
                                InputLabelProps={{ shrink: true }}
                            />
                            </FormControl>
                        </Box>

                        {/* All */}
                        <div className="rowDevice">
                            <div className="col-lg-3">All</div>
                            <div className="col-lg-9">
                                <FormControlLabel
                                    control={
                                    <Checkbox checked={isAllChecked} onChange={handleAll} />
                                    }
                                    label="All Permissions"
                                />
                            </div>
                        </div>

                        {/* Devices */}
                        <div className="rowDevice">
                            <div className="col-lg-3">Devices</div>
                            <div className="col-lg-9">
                            <FormControlLabel
                                control={
                                <Checkbox
                                    checked={rolePermission.devices.includes("view")}
                                    onChange={handleCheckbox("devices", "view")}
                                />
                                }
                                label="View"
                            />
                            <FormControlLabel
                                control={
                                <Checkbox
                                    checked={rolePermission.devices.includes("create")}
                                    onChange={handleCheckbox("devices", "create")}
                                />
                                }
                                label="Create"
                            />
                            </div>
                        </div>

                        {/* Portal */}
                        <div className="rowDevice">
                            <div className="col-lg-3">Portal</div>
                            <div className="col-lg-9">
                            <FormControlLabel
                                control={
                                <Checkbox
                                    checked={rolePermission.portal.includes("view")}
                                    onChange={handleCheckbox("portal", "view")}
                                />
                                }
                                label="View"
                            />
                            <FormControlLabel
                                control={
                                <Checkbox
                                    checked={rolePermission.portal.includes("create")}
                                    onChange={handleCheckbox("portal", "create")}
                                />
                                }
                                label="Create"
                            />
                            </div>
                        </div>

                        <div className="role_permission_btn">
                            <Button type="submit" variant="contained" color="primary">
                                Save Permission
                            </Button>
                        </div>
                    </form>
                 </Grid>
              </Grid>
           </Card>
         </Grid>
      </Grid>
    </Page>


    
  );
}